import React from 'react';
import { Section } from '../components/ui/Section';
import { Button } from '../components/ui/Button';
import { Video, BookOpen, Wrench, ExternalLink } from 'lucide-react';
export const Blog = () => {
  return <div className="pt-20 min-h-screen bg-gray-50" data-id="element-290">
      <div className="bg-[#1C274C] text-white py-20" data-id="element-291">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-292">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-293">
            AI Marketplace
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-294">
            Curated resources, tools, and educational content to support AI
            learning for children, educators, and parents.
          </p>
        </div>
      </div>

      <Section data-id="element-295">
        <div className="max-w-5xl mx-auto" data-id="element-296">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-297">
            <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-[#3AB5E8]/20 text-center" data-id="element-298">
              <div className="w-16 h-16 bg-[#3AB5E8]/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-299">
                <Video className="w-8 h-8 text-[#3AB5E8]" data-id="element-300" />
              </div>
              <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-301">
                Video Library
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-302">
                Educational videos and tutorials on AI concepts for kids and
                educators.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-[#FC963E]/20 text-center" data-id="element-303">
              <div className="w-16 h-16 bg-[#FC963E]/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-304">
                <BookOpen className="w-8 h-8 text-[#FC963E]" data-id="element-305" />
              </div>
              <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-306">
                Learning Guides
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-307">
                Downloadable resources and handbooks for parents and teachers.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm border-2 border-[#389C70]/20 text-center" data-id="element-308">
              <div className="w-16 h-16 bg-[#389C70]/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-309">
                <Wrench className="w-8 h-8 text-[#389C70]" data-id="element-310" />
              </div>
              <h3 className="text-xl font-bold text-[#1C274C] mb-2" data-id="element-311">
                AI Tools
              </h3>
              <p className="text-gray-600 mb-4" data-id="element-312">
                Curated, child-safe AI tools reviewed for educational use.
              </p>
            </div>
          </div>

          {/* YouTube Content Section */}
          <div className="bg-white p-12 rounded-3xl shadow-lg border-2 border-gray-100 text-center" data-id="element-313">
            <div className="w-20 h-20 bg-[#F76874]/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-314">
              <svg className="w-10 h-10 text-[#FF0000]" fill="currentColor" viewBox="0 0 24 24" data-id="element-315">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-316" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-[#1C274C] mb-4" data-id="element-317">
              Watch Our Educational Content
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-318">
              Explore our growing library of educational videos, tutorials, and
              resources on our YouTube channel.
            </p>
            <a href="https://youtube.com/@aiforkidsglobal" target="_blank" rel="noopener noreferrer" data-id="element-319">
              <Button size="lg" className="bg-[#FF0000] hover:bg-[#CC0000]" rightIcon={<ExternalLink className="w-5 h-5" data-id="element-321" />} data-id="element-320">
                Visit Our YouTube Channel
              </Button>
            </a>
          </div>

          {/* Coming Soon Notice */}
          <div className="mt-12 p-8 bg-[#F2F0E7] rounded-2xl text-center" data-id="element-322">
            <p className="text-lg text-gray-700" data-id="element-323">
              <strong data-id="element-324">More resources coming soon!</strong> We're continuously
              curating and creating content to support AI education across
              Africa.
            </p>
          </div>
        </div>
      </Section>
    </div>;
};